import { Controller } from "@hotwired/stimulus";
import { createApp, reactive } from "vue";
import { cities } from "api";
import CityAutocomplete from "../../vue/city_autocomplete";

export default class extends Controller {
  static targets = ["input", "city"];
  static values = { endpoint: String };

  initialize() {
    this.props = reactive({ endpoint: cities.autocomplete });
    this.app = createApp(CityAutocomplete, this.props);
  }

  connect() {
    this.props.endpoint = this.resolveEndpoint();
    this.appNode = document.createElement("div");
    document.body.appendChild(this.appNode);
    this.vm = this.app.mount(this.appNode);

    this.inputTarget.addEventListener("click", () => this.vm.open(true));
    this.appNode.addEventListener("citySelected", (event) =>
      this.citySelected(event.detail),
    );
  }

  disconnect() {
    this.app.unmount();
    this.appNode.remove();
  }

  resolveEndpoint() {
    if (this.endpointValue === "profile") return cities.AutocompleteProfile;

    return cities.autocomplete;
  }

  citySelected(city) {
    this.inputTarget.value = city.label;
    this.cityTarget.value = city.id;
  }
}
